module.exports = __webpack_public_path__ + "img/vignettes-asso_0014_aux-captifs-de-la-liberation.964429da.jpg";